import {Component, OnDestroy, OnInit} from '@angular/core';
import {ExplorerCustomTree} from "@catapp/shared/explorer-custom-tree";
import {ActivatedRoute, Router} from "@angular/router";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {EntitySchemaService} from "@catcore/services/entity-schema.service";
import {BreadcrumbService} from "@catmodules/widgets/breadcrumb/services/breadcrumb.service";
import {ProjectService} from "@catcore/services";
import {GuiZonesService} from "@catdetails/services";
import {Project} from "@catcore/types/api-v2";
import {isNullOrUndefined} from "util";
import {ExplorerItem, TreeNodeInfo} from "@catui/types";
import {GuiZoneExplorerAction} from "@catdetails/types";
import {ProjectUnit} from "@catmodels/project-units/types";
import {Subscription} from "rxjs";

@Component({
  selector: 'catapp-ggw-dynamic-route-templates',
  templateUrl: './ggw-dynamic-route-templates.component.html',
  styleUrls: ['./ggw-dynamic-route-templates.component.scss']
})
export class GgwDynamicRouteTemplatesComponent extends ExplorerCustomTree implements OnInit, OnDestroy {

  private projectSubscription: Subscription;
  private routeTemplatesSubscription: Subscription;

  constructor(route: ActivatedRoute,
              resourceService: GenericResourceService,
              schemaService: EntitySchemaService,
              breadcrumbService: BreadcrumbService,
              private projectService: ProjectService,
              router: Router) {
    super(route, resourceService, schemaService, breadcrumbService, router);
    this.doAllowCreate = true;
    this.setTreeResolveDepth(0);
  }

  ngOnInit() {
    this.projectSubscription = this.projectService
      .getCurrentProject()
      .filter((project: Project) => {
        const isValidProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        return isValidProject;
      })
      .subscribe((project: Project) => {
        this.routeTemplatesSubscription = this.projectService
          .getGgwDynamicRouteTemplates(project)
          .subscribe((values) => {
            this.updateExplorerItems(values);
            this.initNavigationalState();
          });
      });

    this.breadcrumbService.update([{label: 'Dynamic Route Templates', value: 'ggwDynamicRouteTemplates' }]);
  }

  // protected canBeExpanded(nodeInfo: TreeNodeInfo, defaultRouteForward = false){
  //   const excludedResourceRefs = ['parameters'];
  //   let isExcludedResource = !isNullOrUndefined(nodeInfo) && !isNullOrUndefined(nodeInfo.item);
  //   isExcludedResource = isExcludedResource && excludedResourceRefs.includes(nodeInfo.item.value.navItem.ref);
  //
  //   return !isExcludedResource;
  // }

  ngOnDestroy() {
    if (this.routeTemplatesSubscription) {
      this.routeTemplatesSubscription.unsubscribe();
    }
    this.projectSubscription.unsubscribe();
  }

  onActivateItem(nodeInfo: TreeNodeInfo) {
    this.router.navigate([nodeInfo.item.value], {relativeTo: this.route});
  }

  onAddOrCreate() {
    this.router.navigate(['new'], {relativeTo: this.route});
  }

  /**
   *
   * @param $event
   * @param {TreeNodeInfo} nodeInfo
   */
  navigateTo($event, nodeInfo: TreeNodeInfo) {
    $event.stopPropagation();
    this.navigateToTargetRoute(nodeInfo, true);

  }

  /**
   * Returns true if all current conditions, based on the provided TreeNodeInfo, are fullfiled successfuly
   * @param {TreeNodeInfo} item
   * @returns {boolean}
   */
  doDisplayNodeControls(item: TreeNodeInfo): boolean {
    const doAllow = this.doAllowNewItem(item) || this.doAllowDisplayLanding(item);
    return doAllow;
  }

  doAllowNewItem(node: TreeNodeInfo): boolean {
    return node.item.allowedActions.includes(GuiZoneExplorerAction.create);
  }

  doAllowDisplayLanding(node: TreeNodeInfo): boolean {
    return node.item.allowedActions.includes(GuiZoneExplorerAction.info);
  }

  getAllowCreateAction() {
    return GuiZoneExplorerAction.create;
  }

  getAllowInfoAction() {
    return GuiZoneExplorerAction.info;
  }

  private updateExplorerItems(values: any[]) {

    this.explorerItems = [];
    const explorerItems: ExplorerItem[] = [];
    const defaultOptions = {label: () => null, ...this.defaultFactoryOptions};
    const treeNodes = this
      .treeNodeFactory
      .getForRoot(values, {label: () => null, ...this.defaultFactoryOptions})
      .map((explorerItem: ExplorerItem) => {
        explorerItem.allowedActions = [this.getAllowCreateAction(), this.getAllowInfoAction()];
        return explorerItem;
      })
    ;
    this.explorerItems = treeNodes;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-dynamic-routes/components/ggw-dynamic-route-templates/ggw-dynamic-route-templates.component.ts